import { render, staticRenderFns } from "./top-users.vue?vue&type=template&id=6948243e&"
import script from "./top-users.vue?vue&type=script&lang=js&"
export * from "./top-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports